<template>
  <div :class="rootClass" v-if="!isApp" ref="navigation" :style="{ 'padding-top': (paddingTop) + 'px', background: theme.background, color: theme.color }" >
    <div class="top" ref="top" v-show="debug" :style="{ 'height': statusBarHeight + 'px' }"></div>
    <div class="left" v-if="!adaption">
      <slot name="left">
        <div class="back" v-show="showBack" @click="goBack">
          <div class="arrow-back" :style="{ fill: theme.color }">
            <img src="./images/left-button.png" v-if="arrTheme === 'black'">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 18 30" v-else>
              <path fill-rule="evenodd" d="M6.600,15.000 L7.600,14.000 L17.400,4.200 C18.174,3.426 18.174,2.174 17.400,1.399 L17.400,1.399 C16.626,0.626 15.373,0.626 14.599,1.399 L0.001,15.999 L0.001,15.999 L14.599,30.599 C15.373,31.374 16.626,31.374 17.400,30.599 L17.400,30.599 C18.174,29.825 18.174,28.574 17.400,27.799 L7.600,18.000 L6.600,17.000 "></path>
            </svg>

          </div>
        </div>
      </slot>
    </div>

    <div class="center" @click="$emit('center-click')" v-if="!adaption">
      <slot></slot>
    </div>

    <div class="right" @click="$emit('right-click')" v-if="!adaption">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
import router from '../../router'
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import { mapState } from 'vuex'
import { getKey } from '@/assets/utils'
import { isWxMiniprogram } from '../../assets/utils'
export default {
  name: 'navigation',

  description: '导航',

  data () {
    return {
      isApp: false,
      query: this.$route.query,
      dpr: window.dpr
    }
  },

  props: {
    theme: {
      type: Object,
      default: () => {
        return {
          background: '#fff',
          color: 'black'
        }
      }
    },
    arrTheme: {
      type: String,
      default: 'black'
    },
    showBack: {
      type: Boolean,
      default: true
    },

    onBack: {
      type: Function,
      default: () => {
        const currentPage = location.pathname
        router.go(-1)
        let currentTime = new Date().getTime()
        let frame
        const hack = () => {
          if (new Date().getTime() - currentTime > 200) {
            if (location.pathname === currentPage) {
              jsBridge('exit')
            }
            window.cancelAnimationFrame(frame)
          } else {
            window.requestAnimationFrame(hack)
          }
        }

        frame = window.requestAnimationFrame(hack)
      }
    },

    // 是否自定义点击事件
    customClickEvent: {
      type: Boolean,
      default: false
    },

    sticky: {
      type: Boolean,
      default: true
    },

    fixed: {
      type: Boolean,
      default: false
    },

    align: {
      type: String,
      default: 'top' // 可选值top，bottom
    },

    debug: { // 在领分期App内跑需要兼容他们状态栏，打开debug可以看到状态栏高度
      type: Boolean,
      default: false
    },

    adaption: { // 不显示只是为了兼容APP
      type: Boolean,
      default: false
    },

    isPopUp: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rootClass () {
      let cls = ['nd-navigation']
      if (this.fixed) {
        cls.push(`fixed-${this.align}`)
      }
      if (this.sticky) {
        cls.push('sticky')
      }
      if (this.adaption) {
        cls.push('only-adaption')
      }
      return cls
    },

    ...mapState({
      statusBarHeight: state => state.statusBarHeight || getKey('jsBridge', 'statusBarHeight') 
    }),

    paddingTop () {
      return this.isPopUp ? 0 : (this.statusBarHeight / window.dpr || 0)
    }
  },

  methods: {
    goBack () {
      this.$emit('click')
      if (!this.customClickEvent) {
        // 针对app进入做退出优化
        if (hasNativeMethod('exit') && this.isFirstAndApp) {
          jsBridge('exit')
        } else {
          this.onBack()
        }
      }
    }
  },

  created () {
    if (['API-XHQB', 'API-WEIBO'].includes(getKey('channel')) || this.$route.query.hideNav === 'Y' || isWxMiniprogram() || this.isApiH5) {
      this.isApp = true
    }
    // 针对小花小程序复制出来的链接
    if (['API-rosewallet'].includes(getKey('channel')) && getKey('customerSource') === 'XCX' && !isWxMiniprogram()) {
      this.isApp = false
    }
    this.$bus.$on('nativeBack', this.goBack)
  },
  mounted () {
  
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.nd-navigation {
  padding: 0;
  height: 110px;
  justify-content: space-between;
  box-sizing: content-box;
  align-items: center;
  position: relative;
  display: flex;
  background-color: #FFFFFF;
  z-index: 1000;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: @fc1;

  .top {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    background-color: red;
  }
  .left {
    .back {
      height: 80px;
      width: 120px;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      .arrow-back {
        height: 39px;
        width: 22px;
        fill: #333333;

        >img {
          height: 39px;
          width: 22px;
        }
      }
    }
  }

  .right {
    color: #2d8cf0;
    width: 200px;
    text-align: right;
  }

  .center {
   position: absolute;
   width: 100%;
   height: 110px;
   line-height: 110px;
   text-align: center;
   align-items: center;
   pointer-events: none;
  }

  &.transparent {
    background-color: transparent !important;
    border-bottom: none;
  }

  &.white {
    color: #FFFFFF;

    .left {
      .arrow-back {
        fill: #FFFFFF;
      }
    }

    .center {
      color: #FFFFFF;
    }
  }

  &.fixed-top {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }

  &.fixed-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  &.sticky {
    position: sticky;
    top: 0;
  }

  &.only-adaption {
    height: 0;
    z-index: 0;
    background: none !important;
  }
}
</style>